import APIUser from '@/xhr/xhr-user'

const namespaced = true

const initialState = {
  form: {}
}
export const state = { ...initialState }

const getters = {
  form: state => state.form
}

const mutations = {
  setForm (state, data) {
    state.form = data
  },
  clear (state) {
    state.form = {}
  }
}

const actions = {
  // 会員更新
  updateUser ({state, commit}) {
    return new Promise((resolve, reject) => {
      APIUser.editUser({
        surname: state.form.surname,
        first_name: state.form.first_name,
        surname_kana: state.form.surname_kana,
        first_name_kana: state.form.first_name_kana,
        tel: state.form.tel,
        post_code: state.form.post_code,
        prefecture_id: state.form.prefecture_id,
        city_name: state.form.city_name,
        address: state.form.address,
        birthday: state.form.birthday
      }).then((_res) => {
        commit('clear')
        resolve(_res.data)
      }).catch(function (err) {
        reject(err.response)
      })
    })
  }
}

// モジュールに登録されるオブジェクト
export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/accountEdit.js